// extracted by mini-css-extract-plugin
export default {"details":"Details_details__9l4+L","details__loader":"Details_details__loader__Uai91"};